module.exports = __webpack_public_path__ + "static/img/goodness4.6b607897.png";